module.exports = __webpack_public_path__ + "img/DSC_0050.f47f83b6.jpg";